import axios from 'axios'
import CryptoJS from 'crypto-js'
import router from "@/router";
import { Notification } from 'element-ui'
import { clearStoredUser, dispatchFrontAuthExpired, isFrontRoute, restoreAuthAfterPay } from '@/utils/auth'

const API_BASE = process.env.VUE_APP_API_BASE || 'https://api.codebin.xin'
const AES_KEY = process.env.VUE_APP_API_AES_KEY || 'CodeTomApiAes16!'
const AES_KEY_WORDS = CryptoJS.enc.Utf8.parse(AES_KEY)

const request = axios.create({
    baseURL: API_BASE,
    timeout: 30000
})

function decryptApiPayload(payload) {
    if (!payload || typeof payload !== 'object') {
        return payload
    }
    // 未加密的旧格式直接返回
    if (!(payload.e === 1 && typeof payload.d === 'string')) {
        return payload
    }
    try {
        const decrypted = CryptoJS.AES.decrypt(payload.d, AES_KEY_WORDS, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        })
        const plain = decrypted.toString(CryptoJS.enc.Utf8)
        if (!plain) {
            throw new Error('empty decrypt result')
        }
        return JSON.parse(plain)
    } catch (e) {
        console.error('接口响应解密失败', e)
        Notification.error({ message: '数据解密失败，请刷新重试', duration: 3000, showClose: false })
        throw e
    }
}

function shouldIgnoreAuthExpire(config) {
    if (config && config.skipAuthExpire) {
        return true
    }
    const url = (config && config.url) || ''
    // 支付回跳页会顺带拉这些接口；失败不应清登录态
    return /\/order\/status\b/.test(url)
        || /\/order\/sync\b/.test(url)
        || /\/customDevelop\/my\b/.test(url)
        || /\/qa\/my\b/.test(url)
        || /\/qa\/list\b/.test(url)
}

request.interceptors.request.use(config => {
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type']
    } else {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }

    // 支付回跳后可能丢 localStorage，先尝试恢复
    restoreAuthAfterPay()

    let user = JSON.parse(localStorage.getItem("user") || '{}')
    if (user.token) {
        config.headers['token'] = user.token
    } else {
        delete config.headers['token']
    }

    return config
}, error => {
    Notification.error({message: '网络连接超时', duration: 3000, showClose: false})
    return Promise.reject(error)
});

request.interceptors.response.use(
    response => {
        let res = response.data;

        if (typeof res === 'string') {
            try {
                res = res ? JSON.parse(res) : res
            } catch (e) {
                return res
            }
        }

        res = decryptApiPayload(res)

        if (res && res.code === '401') {
            // 支付结果查询接口放行鉴权，不应清登录态
            if (shouldIgnoreAuthExpire(response.config)) {
                return Promise.reject(res)
            }
            clearStoredUser()
            const path = router.currentRoute.path
            if (isFrontRoute(path)) {
                // 用户端静默处理：清登录态并唤起登录，不弹「token验证失败」
                dispatchFrontAuthExpired()
            } else {
                router.push('/login')
            }
            return Promise.reject(res)
        }
        return res;
    }, error => {
        Notification.error({message: '网络连接超时', duration: 3000, showClose: false})
        return Promise.reject(error)
    }
)

export default request
